import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

/**
 * カテゴリタイプリスト
 */
export const CATEGORY_TYPE = [
  '通常',
  '緊急',
  '重要',
  '号外',
  '施設',
  'クラス',
  '保健',
  '給食',
  '感染症関連',
  'バス',
  '送迎',
  'その他',
] as const;

/**
 * カテゴリタイプ
 */
export type CategoryType = typeof CATEGORY_TYPE[number];

/**
 * カテゴリ
 */
export class Category extends PrimitiveValueObject<CategoryType> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: CategoryType): Category {
    return new Category(value);
  }

  /** ラベル */
  static get label(): string {
    return '種類';
  }

  /** プレースホルダー */
  static get placeholder(): string {
    return '通常';
  }

  /** キー */
  static get key(): string {
    return 'category';
  }

  /** バリデーションルール */
  static get validationRule() {
    return {
      /** 必須 */
      required: '必須項目です',
    };
  }

  /** リスト */
  static get list(): {
    /** ID */
    id: string,
    /** 名前 */
    name: string,
  }[] {
    const items = [];
    for (let i = 0; i < CATEGORY_TYPE.length; i += 1) {
      items.push({
        id: CATEGORY_TYPE[i],
        name: CATEGORY_TYPE[i],
      });
    }
    return items;
  }
}
